import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { Text } from "#components/atoms/Typographies/Text";
import { Modal } from "#components/molecules/Modal/Modal";

type Props = {
  opened: boolean;
  onLeave: () => void;
  onKeepEditing: () => void;
};

export const DiscardChangesModal = ({ opened, onLeave, onKeepEditing }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      title={t("optimizations.detail.discard.title")}
      primaryText={t("optimizations.detail.discard.keepEditing")}
      secondaryText={t("optimizations.detail.discard.leave")}
      closeText={t("common.close")}
      onPrimary={onKeepEditing}
      onSecondary={onLeave}
      onClose={onKeepEditing}
    >
      <Text size="small" color={colors.text.secondaryDefault}>
        {t("optimizations.detail.discard.description")}
      </Text>
    </Modal>
  );
};
